export default __webpack_public_path__ + "static/media/google-play-download.47f6c86e.png";